import { Button, Col, Form, Input, Row, Space } from "antd";
import {
  AddDetailBtn,
  RemoveDetailBtn,
  TableUi,
  TwoDecimalInput,
} from "../../ui";
import { ZoomInOutlined } from "@ant-design/icons";
import { useState } from "react";
import { DetalleSeriesLotesModal } from "./modal/DetalleSeriesLotesModal";
const nameTable = "detallesinventarioinicial";
const columns = ({
  filteredColumn,
  handleDelete,
  handleLoteSerieModal,
  form,
}) => [
  {
    title: "#",
    dataIndex: "nro",
    key: "nro",
    render: (text, record, index) => <>{index + 1}</>,
  },
  {
    title: "Item",
    dataIndex: "nombre",
    key: "nombre",
    width: "50%",
    render: (text, field, index) => (
      <>{form.getFieldValue([nameTable, field.name, "nombre"])}</>
    ),
    filteredValue: [filteredColumn],
    onFilter: (value, record) =>
      String(form.getFieldValue([nameTable, record.name, "nombre"]))
        .toLowerCase()
        .includes(value.toLowerCase()),
  },
  {
    title: "Stock inicial",
    dataIndex: "cantidad",
    key: "cantidad",
    render: (text, field, index) => (
      <>
        <Space size="middle">
          <Form.Item
            name={[field.name, "cantidad"]}
            className="classRowFieldTable"
            rules={[
              {
                required: true,
                message: "El stock inicial es obligatorio",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const manejalotes =
                    form.getFieldValue([
                      nameTable,
                      field.name,
                      "manejalotes",
                    ]) || false;
                  const manejaseries =
                    form.getFieldValue([
                      nameTable,
                      field.name,
                      "manejaseries",
                    ]) || false;

                  if (manejalotes) {
                    const lotes = getFieldValue([
                      nameTable,
                      field.name,
                      "detalleslotesinventarioinicial",
                    ]);
                    const suma = lotes?.reduce(
                      (prev, curr) => Number(prev) + Number(curr?.cantidad),
                      0,
                    );
                    if (parseFloat(value) === parseFloat(suma))
                      return Promise.resolve();
                    return Promise.reject(
                      new Error(
                        "La suma de las cantidades de los lotes no es igual a la cantidad del stock inicial",
                      ),
                    );
                  }
                  if (manejaseries) {
                    const series = getFieldValue([
                      nameTable,
                      field.name,
                      "detallesseriesinventarioinicial",
                    ]);
                    if (parseFloat(series?.length) === parseFloat(value))
                      return Promise.resolve();
                    return Promise.reject(
                      new Error(
                        "El cantidad de las series no es igual a la cantidad del stock inicial",
                      ),
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <TwoDecimalInput
              placeholder="Ingrese Stock inicial"
              style={{ width: "100%", textAlign: "right" }}
              suffix={form.getFieldValue([
                nameTable,
                field.name,
                "prefijounidadmedida",
              ])}
              disabled={
                form.getFieldValue([nameTable, field.name, "estado"]) === true
              }
            />
          </Form.Item>
          {form.getFieldValue([nameTable, field.name, "manejalotes"]) && (
            <Button
              icon={<ZoomInOutlined />}
              onClick={() =>
                handleLoteSerieModal(
                  form.getFieldValue([nameTable, field.name]),
                )
              }
              disabled={
                form.getFieldValue([nameTable, field.name, "estado"]) === true
              }
            >
              Lotes
            </Button>
          )}
          {form.getFieldValue([nameTable, field.name, "manejaseries"]) && (
            <Button
              icon={<ZoomInOutlined />}
              onClick={() =>
                handleLoteSerieModal(
                  form.getFieldValue([nameTable, field.name]),
                )
              }
              disabled={
                form.getFieldValue([nameTable, field.name, "estado"]) === true
              }
            >
              Series
            </Button>
          )}
        </Space>
      </>
    ),
  },
  {
    title: "Costo",
    dataIndex: "costo",
    key: "costo",
    render: (text, field, index) => (
      <>
        <Form.Item
          name={[field.name, "costo"]}
          className="classRowFieldTable"
          rules={[
            {
              required: true,
              message: "El costo es obligatorio",
            },
          ]}
        >
          <TwoDecimalInput
            placeholder="Ingrese costo"
            style={{ width: "100%", textAlign: "right" }}
            suffix={form.getFieldValue([
              nameTable,
              field.name,
              "prefijomoneda",
            ])}
            disabled={
              form.getFieldValue([nameTable, field.name, "estado"]) === true
            }
          />
        </Form.Item>
      </>
    ),
  },
  {
    title: "",
    dataIndex: "acciones",
    key: "acciones",
    align: "center",
    render: (text, field, index) => (
      <Space size="middle">
        <RemoveDetailBtn
          tabIndex={-1}
          onClick={() => handleDelete(field)}
          disabled={
            form.getFieldValue([nameTable, field.name, "estado"]) === true
          }
        />
      </Space>
    ),
  },
];
export const DetalleInventarioInicialTable = ({
  data,
  remove,
  handleOpenModal,
}) => {
  const [dataSerieLote, setDataSerieLote] = useState(null);
  const [openModalLoteSerie, setOpenModalLoteSerie] = useState(false);
  const [searchText, setSearchText] = useState("");
  const form = Form.useFormInstance();
  const handleCloseLoteSerieModal = () => setOpenModalLoteSerie(false);
  const handleOpenLoteSerieModal = () => setOpenModalLoteSerie(true);
  const handleDelete = (field) => remove(field?.name);
  const handleLoteSerieModal = (data) => {
    setDataSerieLote(data);
    handleOpenLoteSerieModal();
  };
  const onSearch = (value, e) => {
    e.preventDefault();
    setSearchText(value);
  };
  return (
    <>
      <TableUi
        data={data}
        columns={columns({
          filteredColumn: searchText,
          handleDelete,
          handleLoteSerieModal,
          form,
        })}
        size="small"
        title={() => (
          <>
            <Row>
              <Col flex={2}>
                <Input.Search
                  placeholder="Buscar"
                  allowClear
                  onSearch={onSearch}
                  enterButton
                />
              </Col>
              <Col flex={1} style={{ textAlign: "right" }}>
                <AddDetailBtn onClick={handleOpenModal} />
              </Col>
            </Row>
          </>
        )}
      />
      <DetalleSeriesLotesModal
        open={openModalLoteSerie}
        onCancel={handleCloseLoteSerieModal}
        manejalotes={dataSerieLote?.manejalotes}
        manejaseries={dataSerieLote?.manejaseries}
        cantidad={dataSerieLote?.cantidad}
        series={dataSerieLote?.detallesseriesinventarioinicial || []}
        lotes={dataSerieLote?.detalleslotesinventarioinicial || []}
        item={dataSerieLote?.id}
      />
    </>
  );
};
